import styles from './loader.module.css'

const Loader = ({ title = "" }) => {
  return (
    <div className={styles.container}>
      <img src='/Pharmacy_logo_1.svg' alt="Loading..." className={styles.logo} />
      {title && <p className={styles.text}>{title}</p>}
    </div>
  );
};

export default Loader;
